<template>
  <div><slot/></div>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>

</style>
